import React, {Component} from 'react';

export default class Textarea extends Component {

    onBlur = (event) => {
        const {
            name,
        } = this.props.params;

        const value = event.target.value;

        if (value) {
            this.props.setField(
                name,
                value,
                '',
            );

            return;
        }

        if (
            this.props.state.fields[name].role.required
        ) {
            this.props.setField(
                name,
                value,
                'Kötelező megadni',
            );
        }
    };

    onChange = (event) => {
        const value = event.target.value;

        if (
            value.indexOf('<') < 0
            && value.indexOf('>') < 0
        ) {
            this.props.setField(
                this.props.params.name,
                value,
            );
        }
    };

    render() {
        const {
            params,
            state,
        } = this.props;

        const field = state.fields[params.name];

        const hasError = field.error
            ? 'has-error'
            : '';

        return (
            <div
                className={
                    `field field-textarea ${params.id} ${hasError}`
                }
                style={params.style}
            >
                <div>
                    <label
                        htmlFor={params.id}
                        className={params.classLabel}
                    >
                        {params.label}
                    </label>

                    <textarea
                        spellCheck="false"
                        className={params.classInput}
                        autoComplete="off"
                        id={params.id}
                        name={params.name}
                        onBlur={this.onBlur}
                        onChange={this.onChange}
                        value={field.value || ''}
                        disabled={params.disabled}
                    />

                    {field.error ? (
                        <span className="error">
                            <i className="fa fa-warning" />
                            {' '}
                            {field.error}
                        </span>
                    ) : null}
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/common/fields/Textarea.js